export default "__VITE_ASSET__CjZTeBX6__"